import { createBrowserRouter } from "react-router-dom";

import HomeLayout from "./layouts/HomeLayout";
import MainLayout from "./layouts/MainLayout";

import Apps from "./pages/Apps/Apps";
import CallCenter from "./pages/CallCenter/CallCenter";
import Chat from "./pages/Chat/Chat";
import Contacts from "./pages/Contacts/Contacts";
import Home from "./pages/Home/Home";
import Agreements from "./pages/PolicyPages/Agreements";
import SLA from "./pages/PolicyPages/SLA";
import TermsConditions from "./pages/PolicyPages/TermsConditions";
import Warranties from "./pages/PolicyPages/Warranties";
import Prices from "./pages/Prices/Prices";
import Voip from "./pages/Voip/Voip";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <HomeLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "chat", element: <Chat /> },
    ],
  },
  {
    path: "/",
    element: <MainLayout />,
    children: [
      { path: "prices", element: <Prices /> },
      { path: "callCenter", element: <CallCenter /> },
      { path: "voip", element: <Voip /> },
      { path: "warranties", element: <Warranties /> },
      { path: "agreements", element: <Agreements /> },
      { path: "termsConditions", element: <TermsConditions /> },
      { path: "sla", element: <SLA /> },
      { path: "contacts", element: <Contacts /> },
      { path: "apps", element: <Apps /> },
    ],
  },
]);
